import React from "react";
import { ShoppingCard } from "./ShoppingCard";

const Shoppings = ({ t }) => {
  const styles = {
    shoppingsContainer: {
      backgroundColor: '#f8f9fa',
      padding: '60px 0',
      position: 'relative',
      overflow: 'hidden',
    },
    backgroundPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, rgba(52, 152, 219, 0.05) 0%, rgba(155, 89, 182, 0.05) 100%)',
      zIndex: 1,
    },
    containerFluid: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
      position: 'relative',
      zIndex: 2,
    },
    row: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      gap: '0',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
      border: '1px solid #e9ecef',
    },
    cardWrapper: {
      flex: '1',
      maxWidth: '250px',
      minWidth: '200px',
      position: 'relative',
    },
    shoppingCard: {
      padding: '40px 25px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      position: 'relative',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
      borderRight: '1px solid #e9ecef',
      backgroundColor: 'white',
      cursor: 'pointer',
    },
    shoppingCardLast: {
      borderRight: 'none',
    },
    shoppingCardHover: {
      transform: 'translateY(-8px)',
      backgroundColor: '#fff',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
      zIndex: 10,
    },
    iconContainer: {
      width: '80px',
      height: '80px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '25px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      position: 'relative',
      transition: 'all 0.4s ease',
    },
    iconContainerHover: {
      transform: 'scale(1.1) rotate(5deg)',
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    },
    icon: {
      fontSize: '32px',
      color: 'white',
      transition: 'all 0.3s ease',
    },
    iconGlow: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%)',
      opacity: 0,
      transition: 'opacity 0.3s ease',
    },
    iconGlowActive: {
      opacity: 1,
    },
    title: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#2c3e50',
      marginBottom: '12px',
      lineHeight: '1.3',
      transition: 'all 0.3s ease',
    },
    titleHover: {
      color: '#667eea',
      transform: 'translateY(-2px)',
    },
    description: {
      fontSize: '14px',
      color: '#7f8c8d',
      lineHeight: '1.6',
      fontWeight: '500',
      opacity: 0.9,
      transition: 'all 0.3s ease',
      maxWidth: '180px',
    },
    descriptionHover: {
      color: '#5a6c7d',
      opacity: 1,
    },
    decorativeElement: {
      position: 'absolute',
      bottom: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '0',
      height: '4px',
      background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
      transition: 'width 0.4s ease',
      borderRadius: '2px 2px 0 0',
    },
    decorativeElementActive: {
      width: '60%',
    },
    // Responsive styles
    '@media (max-width: 768px)': {
      row: {
        flexDirection: 'column',
        gap: '1px',
      },
      cardWrapper: {
        maxWidth: '100%',
      },
      shoppingCard: {
        borderRight: 'none',
        borderBottom: '1px solid #e9ecef',
      },
      shoppingCardLast: {
        borderBottom: 'none',
      },
    },
  };

  const EnhancedShoppingCard = ({ title, p, icon, isLast }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    return (
      <div style={styles.cardWrapper}>
        <div
          style={{
            ...styles.shoppingCard,
            ...(isLast ? styles.shoppingCardLast : {}),
            ...(isHovered ? styles.shoppingCardHover : {}),
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div
            style={{
              ...styles.iconContainer,
              ...(isHovered ? styles.iconContainerHover : {}),
            }}
          >
            <i
              className={icon}
              style={styles.icon}
            />
            <div
              style={{
                ...styles.iconGlow,
                ...(isHovered ? styles.iconGlowActive : {}),
              }}
            />
          </div>
          
          <h5
            style={{
              ...styles.title,
              ...(isHovered ? styles.titleHover : {}),
            }}
          >
            {title}
          </h5>
          
          <p
            style={{
              ...styles.description,
              ...(isHovered ? styles.descriptionHover : {}),
            }}
          >
            {p}
          </p>
          
          <div
            style={{
              ...styles.decorativeElement,
              ...(isHovered ? styles.decorativeElementActive : {}),
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <div style={styles.shoppingsContainer}>
      <div style={styles.backgroundPattern} />
      <div style={styles.containerFluid}>
        <div style={styles.row}>
          <EnhancedShoppingCard 
            title={t("fre")} 
            p={t("frep")} 
            icon="fa fa-ship" 
          />
          <EnhancedShoppingCard 
            title={t("mong")} 
            p={t("thirt")} 
            icon="fa fa-usd" 
          />
          <EnhancedShoppingCard 
            title={t("saf")} 
            p={t("safg")} 
            icon="fa fa-shopping-cart" 
          />
          <EnhancedShoppingCard 
            title={t("onl")} 
            p={t("wes")} 
            icon="fa fa-internet-explorer" 
            isLast={true}
          />
        </div>
      </div>
    </div>
  );
};

export default Shoppings;